export default "__VITE_ASSET__f1a057e3__"